var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12.6C9.25 12.2962 9.50184 12.05 9.8125 12.05H13.1875C13.4982 12.05 13.75 12.2962 13.75 12.6C13.75 12.9038 13.4982 13.15 13.1875 13.15H9.8125C9.50184 13.15 9.25 12.9038 9.25 12.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 10.125C9.50184 10.125 9.25 10.3712 9.25 10.675C9.25 10.9788 9.50184 11.225 9.8125 11.225H13.1875C13.4982 11.225 13.75 10.9788 13.75 10.675C13.75 10.3712 13.4982 10.125 13.1875 10.125H9.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14.525C9.25 14.2212 9.50184 13.975 9.8125 13.975H13.1875C13.4982 13.975 13.75 14.2212 13.75 14.525C13.75 14.8288 13.4982 15.075 13.1875 15.075H9.8125C9.50184 15.075 9.25 14.8288 9.25 14.525Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.375 6C9.75368 6 9.25 6.49249 9.25 7.1L8.6875 7.1C7.75552 7.1 7 7.83873 7 8.75V15.35C7 16.2613 7.75552 17 8.6875 17H14.3125C15.2445 17 16 16.2613 16 15.35V8.75C16 7.83873 15.2445 7.1 14.3125 7.1H13.75C13.75 6.49249 13.2463 6 12.625 6H10.375ZM12.625 7.1H10.375V8.2H12.625V7.1ZM9.25 8.2H8.6875C8.37684 8.2 8.125 8.44624 8.125 8.75V15.35C8.125 15.6538 8.37684 15.9 8.6875 15.9H14.3125C14.6232 15.9 14.875 15.6538 14.875 15.35V8.75C14.875 8.44624 14.6232 8.2 14.3125 8.2H13.75C13.75 8.80751 13.2463 9.3 12.625 9.3H10.375C9.75368 9.3 9.25 8.80751 9.25 8.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignDescription);
export default __webpack_public_path__ + "static/media/campaign-description.93f9b56db85c8b58917302f5b85a6e46.svg";
export { ForwardRef as ReactComponent };